import { timestamp } from "@fusion-advantage/formlib"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { resetAppFormState } from "./actions"

export interface BackgroundSliceState {
	draftSaveTimeoutId: ReturnType<typeof setTimeout>|null
	formLastLegacyDraftSaveRequestAt: string|null
	formLastBackgroundDraftSaveAt: string|null
	syncTimeoutId: ReturnType<typeof setTimeout>|null
}

const initialState: BackgroundSliceState = {
	draftSaveTimeoutId: null,
	formLastLegacyDraftSaveRequestAt: null,
	formLastBackgroundDraftSaveAt: null,
	syncTimeoutId: null,
}

const backgroundSlice = createSlice({
	name: 'background',
	initialState,
	reducers: {
		setBackgroundDraftSaveTimeoutId(state, action: PayloadAction<BackgroundSliceState["draftSaveTimeoutId"]>) {
			state.draftSaveTimeoutId = action.payload
		},
		recordBackgroundLegacyDraftSaveRequest(state) {
			// use same format as submitStatusUpdates
			state.formLastLegacyDraftSaveRequestAt = timestamp()
		},
		setBackgroundSyncTimeoutId(state, action: PayloadAction<BackgroundSliceState["syncTimeoutId"]>) {
			state.syncTimeoutId = action.payload
		},
	},
	extraReducers: (builder) => {
		builder.addCase(resetAppFormState, (state): BackgroundSliceState => {
			return {
				...state,
				formLastLegacyDraftSaveRequestAt: null,
				formLastBackgroundDraftSaveAt: null,
			}
		})
	},
})

export const {
	setBackgroundDraftSaveTimeoutId,
	recordBackgroundLegacyDraftSaveRequest,
	setBackgroundSyncTimeoutId,
} = backgroundSlice.actions
export default backgroundSlice.reducer

